// src/features/tidsregistering/hooks/usePlannedShifts.js
import { useState, useCallback } from 'react';
import { plannedShiftsAPI } from '../services/plannedShifts';
import { useApi } from '../../../hooks/api/useApi';

export function usePlannedShifts() {
  const [plannedShifts, setPlannedShifts] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchForDepartment = useCallback(async (startDate, endDate) => {
    const result = await execute(() => plannedShiftsAPI.listForDepartment(startDate, endDate));
    if (result.success) setPlannedShifts(result.data?.planned_shifts ?? []);
    return result;
  }, [execute]);

  const createShift = useCallback(async (data) => {
    const result = await execute(() => plannedShiftsAPI.createShift(data));
    return result;
  }, [execute]);

  const updateShift = useCallback(async (plannedShiftId, data) => {
    const result = await execute(() => plannedShiftsAPI.updateShift(plannedShiftId, data));
    return result;
  }, [execute]);

  const deleteShift = useCallback(async (plannedShiftId) => {
    const result = await execute(() => plannedShiftsAPI.deleteShift(plannedShiftId));
    return result;
  }, [execute]);

  return {
    plannedShifts,
    loading,
    error,
    clearError,
    fetchForDepartment,
    createShift,
    updateShift,
    deleteShift,
  };
}
